export default {
  "content": "<path d=\"M19 17h4v2h-4v4h-2v-4h-4v-2h4v-4h2v4z\" fill=\"#7B61FF\"/><path d=\"M12 12c1.14 0 2.24.153 3.265.435l-.53 1.927A10.33 10.33 0 0012 14c-4.159 0-7.256 2.308-7.882 5H11v2H3a1 1 0 01-1-1c0-4.638 4.726-8 10-8z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 2.5a4 4 0 110 8 4 4 0 010-8zm0 2a2 2 0 100 4 2 2 0 000-4z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};